import { Users, UserPlus, TrendingUp, Trophy } from "lucide-react";

function TrendBadge({ value }) {
  if (value === 0) {
    return <span className="text-xs text-gray-400">sin cambios</span>;
  }
  const positive = value > 0;
  return (
    <span
      className={`text-xs font-medium ${
        positive ? "text-emerald-600" : "text-red-600"
      }`}
    >
      {positive ? "↑" : "↓"} {Math.abs(value)}% vs mes anterior
    </span>
  );
}

function Card({ icon: Icon, label, value, color, trend, subtitle }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-start gap-4">
        <div
          className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${color}`}
        >
          <Icon size={22} className="text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-sm text-gray-500">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {trend !== undefined && <TrendBadge value={trend} />}
          {subtitle && (
            <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default function KpiCards({
  totalStudents,
  newThisMonth,
  newPrevMonth,
  avgProgress,
  finishedCount,
}) {
  const trend =
    newPrevMonth === 0
      ? newThisMonth > 0
        ? 100
        : 0
      : Math.round(((newThisMonth - newPrevMonth) / newPrevMonth) * 100);

  const finishedPct =
    totalStudents > 0
      ? Math.round((finishedCount / totalStudents) * 100)
      : 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card
        icon={Users}
        label="Alumnos totales"
        value={totalStudents}
        color="bg-blue-500"
      />
      <Card
        icon={UserPlus}
        label="Nuevos este mes"
        value={newThisMonth}
        color="bg-indigo-500"
        trend={trend}
      />
      <Card
        icon={TrendingUp}
        label="Progreso medio"
        value={`${avgProgress}%`}
        color="bg-emerald-500"
      />
      <Card
        icon={Trophy}
        label="Han finalizado"
        value={finishedCount}
        color="bg-amber-500"
        subtitle={`${finishedPct}% del total`}
      />
    </div>
  );
}
